import { useTranslation } from "react-i18next";

export const useI18ports = () => {
  const { t } = useTranslation();

  const ports = [
    {
      id: "POPULAR",
      port: t("portScanner.popularPorts.port.1"),
    },
    {
      id: "SERVER",
      port: t("portScanner.popularPorts.port.2"),
    },
    {
      id: "GAME",
      port: t("portScanner.popularPorts.port.3"),
    },
    {
      id: "APPLICATION",
      port: t("portScanner.popularPorts.port.4"),
    },
    {
      id: "P2P",
      port: t("portScanner.popularPorts.port.5"),
    },
  ];

  return { ports };
};
